import React from 'react'
import EmptyStateIcon from './svgr/EmptyStateIcon'

const EmptyState = ({title, subtitle}:{title:string, subtitle:string}) => {
  return (
    <div className='empty-state'>
        <div>
            <EmptyStateIcon />
            <h2>{title}</h2>
            <p>{subtitle}</p>
        </div>
    </div>
  )
}

export default EmptyState